import { create } from 'zustand';

const useEditProfileStore = create((set) => ({
  open: false,
  userProfile: null,
  header: 'Profile Information',
  setExternalOpen: (open, header) =>
    set((state) => ({
      open: open,
      header: header,
      userProfile: state.userProfile,
    })),
  setOpen: (isOpen, userProfile, header) =>
    set(() => ({ open: isOpen, userProfile: userProfile, header: header })),
  join: () => {},
}));

export default useEditProfileStore;
